import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useFirebaseAuth(): useFirebaseAuthReturn {
  return useLazyContext(FirebaseAuthContext);
}

export type useFirebaseAuthReturn = {
  userId: string;
  authenticated: boolean;

  name?: string;
  email?: string;
  photoUrl?: string;

  signInWithGoogle: (loginHint?: string) => Promise<void>;
  signUpWithGoogle: () => Promise<void>;
  signInWithEmail: (credentials: EmailCredentials) => Promise<void>;
  signUpWithEmail: (credentials: EmailCredentials) => Promise<void>;
  sendPasswordResetEmail: (email: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export type EmailCredentials = {
  email: string;
  password: string;
};

export const FirebaseAuthContext =
  createContext<LazyValue<useFirebaseAuthReturn>>(undefined);
